import { useMemo } from "react";
import Button from "components/atoms/Button";
import useTranslate from "hooks/useTranslate";
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";
import { createSearchParams, useNavigate } from "react-router-dom";
import RewardsItem from "./RewardsItem";
import { useFortuneWheelStore } from "../../store/fortuneWheel";
import RewardsItemSkeleton from "./RewardsItem/RewardsItem.skeleton";
import "./styles.sass";

type Props = {
  isLoading?: boolean;
};

const Rewards: React.FC<Props> = ({ isLoading }) => {
  const t = useTranslate();

  const sectionList = useFortuneWheelStore((s) => s.sectionList);

  const navigate = useNavigate();

  const handleOpenConditions = () => {
    navigate({
      search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.fortuneWheelConditions })}`,
    });
  };

  const rewardsContent = useMemo(
    () =>
      isLoading
        ? Array(8)
            .fill(null)
            // eslint-disable-next-line react/no-array-index-key
            .map((_, index) => <RewardsItemSkeleton key={index} />)
        : sectionList.map((item) => <RewardsItem key={item.id} item={item} />),
    [isLoading, sectionList],
  );

  return (
    <div className="Rewards">
      <div className="Rewards__title">{t("wheel.fortune.reward.title")}</div>

      <div className="Rewards__content">{rewardsContent}</div>

      <Button
        variation="primary"
        label="Полные условия"
        disabled={isLoading}
        onClick={handleOpenConditions}
      />
    </div>
  );
};

export default Rewards;
